import {CityService} from '../service/city.service';
import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {DropdownFormControl} from '../dropdown-form-control/dropdown-form-control';
import {ControlContainer, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR} from '@angular/forms';
import { ActivatedRoute } from '@angular/router'

@Component({
    selector: 'app-city-dropdown',
    templateUrl: 'city-dropdown.component.html',
    styleUrls: ['city-dropdown.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CityDropdownComponent),
        multi: true
    }],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}]
})
export class CityDropdownComponent extends DropdownFormControl<string> implements OnInit {
    private readonly cityService: CityService;
    private readonly route: ActivatedRoute;
    public filteredCities: string[];
    @Input() public formControlData: FormControl = null;

    constructor(cityService: CityService, route: ActivatedRoute) {
        super();
        this.cityService = cityService;
        this.route = route;
    }

    public async ngOnInit(): Promise<void> {
        this.route.queryParams.subscribe(async params => {
            const cities = await this.cityService.getAll( params['channel-partner-id']);
            this.allValues = cities.map(c => c.name);
        });
    }

    getCityName() {
        let cityName = this.selectedValue;
        if (cityName?.length < 3) {
            this.filteredCities = null;
        } else {
            this.filteredCities =  this.filterCityNames(this.selectedValue);
        }
    }

    validateCity(event: Event) {
        const isCityPresent = !!this.allValues.find((city) => city == this.selectedValue);
        if (!isCityPresent) {
            this.formControlData.setErrors({'cityListError': true});
        }
    }

    private filterCityNames(val: string): string[] {
        return this.allValues?.filter(city => city.toLowerCase().startsWith(val?.toLowerCase()));
    }
}
